import { EndpointSetting } from "@/constants/app/type";
import { HotelState } from "../type";
import { normalizeHotelFilterOptions } from "@/utils/hotel/normalizeHotelFilterOptions";

export const callbackFilterOptions: EndpointSetting['caller'] = (
  state: HotelState,
  action: any,
  endpointName: any
) => {
  const payload = action.payload
  const data = normalizeHotelFilterOptions(payload)

  if (Object.keys(data).length === 0) {
    // Keep called=false so getMetadataHotel can retry with a valid list.
    state.hotels_filter_option.loading = false
    state.hotels_filter_option.error = null
    return
  }

  state.hotels_filter_option.loading = false
  state.hotels_filter_option.called = true
  state.hotels_filter_option.error = null
  state.hotels_filter_option.data = data
}
